import React from "react";

const Objective = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M18.004 2.002A16.014 16.014 0 0 0 2 18a16.006 16.006 0 0 0 16.004 16 16.015 16.015 0 0 0 13.516-7.453 16.005 16.005 0 0 0 .94-15.404l-1.588 1.586a1.603 1.603 0 0 1-1.135.474h-.443a12.16 12.16 0 0 1 .98 4.797 12.273 12.273 0 0 1-12.27 12.267c-6.77 0-12.27-5.498-12.27-12.267A12.273 12.273 0 0 1 16.888 5.79a12.28 12.28 0 0 1 5.916.923v-.444c0-.425.17-.834.472-1.135l1.588-1.588a15.932 15.932 0 0 0-6.86-1.544Zm10.12 0a.534.534 0 0 0-.362.157L24.028 5.89a.534.534 0 0 0-.157.38v3.512l-7.045 7.043a1.672 1.672 0 0 0 0 2.354 1.67 1.67 0 0 0 2.353-.004l7.042-7.04h3.516a.535.535 0 0 0 .38-.158l3.731-3.732a.534.534 0 0 0-.377-.908h-2.45l.426-.427a1.67 1.67 0 0 0 .004-2.35 1.665 1.665 0 0 0-1.18-.484 1.66 1.66 0 0 0-1.177.484l-.423.423v-2.45a.534.534 0 0 0-.546-.53Zm-10.12 7.464c-4.708 0-8.538 3.83-8.538 8.534 0 4.704 3.83 8.532 8.538 8.532A8.541 8.541 0 0 0 26.536 18a8.5 8.5 0 0 0-.891-3.78l-2.924 2.923a4.803 4.803 0 0 1-4.717 5.656 4.807 4.807 0 0 1-4.8-4.797 4.805 4.805 0 0 1 4.798-4.8c.294 0 .58.031.859.082l2.923-2.923a8.469 8.469 0 0 0-3.78-.895Z"
        />
    </svg>
);

export default Objective;